import React from 'react';
import classes from './Form.module.css';
import { phoneIcon, clockIcon, locationIcon } from '../../../shared/fontAwesomeIcons/fontAwesomeIcons';
import { FormConstants } from '../../../constants/FormConstants';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useState} from 'react';
import '../../../index.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CONTACT_ME_SHEET_ID, CLIENT_EMAIL, PRIVATE_KEY, doc,
    A_CONTACT_ME_SHEET_ID, A_CLIENT_EMAIL, A_PRIVATE_KEY, adoc, 
    getCurrentDate, getCurrentDay } from '../../../shared/gsheetConstants';
import $ from 'jquery';

const formInformation = FormConstants.FORM_INFORMATION;
const formFields = FormConstants.FORM_INFORMATION.FORM_INPUT.FORM_INPUT_FIELDS;
const stores = FormConstants.FORM_INFORMATION.FORM_INPUT.STORES;

function getIcon (value) {
    switch(value) {
        case 'phoneIcon':
            return phoneIcon;
        case 'clockIcon':
            return clockIcon;
        case 'locationIcon':
            return locationIcon;
        default:
            return phoneIcon;
    }
}

const Form = (props) => {
    const [isRequested, setIsRequested] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [store, setStore] = useState('Velachery');
    const [isSubmissionDisabled, setDisable] = useState(true);
    
    function getMethod (e, field) {

        if (firstName !== null && lastName !== null && email !== null 
            && firstName !== '' && lastName !== '' && email !== '') {
            setDisable(false);
        } else {
            setDisable(true);
        }

        switch(field) {
            case formFields[0]: 
                return setFirstName(e.target.value);
            case formFields[1]: 
                return setLastName(e.target.value);
            case formFields[3]: 
                return setEmail(e.target.value);
            case formFields[4]: 
                return setMessage(e.target.value);
            case formFields[2]:
                return setPhone(e.target.value);
            default:
                return;
        }

       
    }

    async function handleSubmit(event) {
        setIsRequested(true);
        event.preventDefault();
        const newEntry = { 
            Date: getCurrentDate(),
            Day: getCurrentDay(),
            FirstName: firstName, 
            LastName: lastName , 
            Email: email, 
            Message: message, 
            ServiceInterested: props.service,
            PhoneNumber: phone
        };
        await submitGetInTouchForm(newEntry);
    }

    async function submitGetInTouchForm (row) {
        try {
            const sheet = await createDocumentObjectByStoreLocation(store);
            await sheet.addRow(row);
            setIsRequested(false);
            $("#contactMeForm")[0].reset();
            props.showToast('success', 'Success', 'Your request has been submitted.');
          } catch (e) {
            setIsRequested(false);
            props.showToast('error', 'Error', 'Oops! Something went wrong.');
          }
    }

    async function createDocumentObjectByStoreLocation(location) {
        try {
                    if (location === 'Velachery') {
                        await doc.useServiceAccountAuth({
                            client_email: CLIENT_EMAIL,
                            private_key: PRIVATE_KEY.replace(/\\n/g, '\n')
                            });
                            // loads document properties and worksheets
                            await doc.loadInfo();
                            const sheet = doc.sheetsById[CONTACT_ME_SHEET_ID];
                            return sheet;
                        } else if (location === 'Anna Nagar') {
                            await adoc.useServiceAccountAuth({
                                client_email: A_CLIENT_EMAIL,
                                private_key: A_PRIVATE_KEY.replace(/\\n/g, '\n')
                            });
                            await adoc.loadInfo();
                            const sheet = adoc.sheetsById[A_CONTACT_ME_SHEET_ID];
                            return sheet;
                        } else {
                            throw new Error("Invalid store location");
                        }
        } catch (error) {
            throw new Error("Error creating document object: " + error.message);
        }
    }

    return(
        <div className={classes.form_container}>
            <div className={classes.information_container}>
                <div className={classes.information_container__title}>
                    {formInformation.TITLE}
                </div>
            <div className={classes.information_container__location}>
                {formInformation.LOCATION.map((location, index) => (
                    <div key={index} className={classes.information_container__location_block}>
                        {/* Address */}
                        <div>
                            <strong>{location.PLACE}</strong><br />
                            {location.ADDRESSLINE_1}<br />
                            {location.ADDRESSLINE_2}<br />
                        </div>
                        {/* Contact Info */}
                        <div className={classes.information_container__contact_detail}>
                            {/* Phone */}
                            <div>
                                <a href={`tel:${location.PHONE}`} target="_blank" rel="noreferrer nofollow">
                                    <span>{getIcon('phoneIcon')}</span>
                                    <span>{location.PHONE}</span>
                                </a>
                            </div>
                            {/* Google Maps */}
                            <div>
                                <a href={location.GMAP} target="_blank" rel="noreferrer nofollow">
                                    <span>{getIcon('locationIcon')}</span>
                                    <span>Get Directions</span>
                                </a>
                            </div>
                            {/* Timings */}
                            <div>
                                <span>{getIcon('clockIcon')}</span>
                                <span>{location.TIMINGS}</span>
                            </div>
                        </div>
                        <br />
                    </div>
                ))}
            </div>

            </div>
            <div className={classes.form_input_container}>
                <div className={classes.information_container__title}>
                    {formInformation.FORM_INPUT.FORM_TITLE}
                </div>
                <div>    
                    <form id="contactMeForm" onSubmit={handleSubmit}>
                    {
                        formFields.map((field, index) => {
                            return (
                                    <TextField key={index}
                                    className={classes.form_input}
                                        id={field} 
                                        label={field}
                                        onInput={ e=>getMethod(e, field)}
                                        variant="outlined" 
                                        fullWidth
                                        required/>
                            );
                        })
                    }
                    <TextField
                        select
                        className={classes.form_input}
                        id ="store"
                        label="Preferred Store"
                        value={store}
                        onChange={(e) => setStore(e.target.value)}
                        variant="outlined"
                        fullWidth
                        required>
                        {stores.map((store, idx) => (
                            <MenuItem key={idx} value={store}>
                                {store}
                            </MenuItem>
                        ))}
                    </TextField>
                    <div className={classes.button_container}>
                        {
                            <button 
                            className="button_variant_3" 
                            type="submit" 
                            disabled={isSubmissionDisabled || isRequested}>
                                {
                                    isRequested ? <CircularProgress size={24} /> : 'GET IN TOUCH'
                                }
                            </button>
                        }
                        
                    </div>
                    </form>
                    
                </div>
            </div>
        </div>
    )
}

export default Form;